import { observable, set } from 'mobx';

export interface IProduct {
    skuId: string;
    productId: string;
    name: string;
    size: string;
    imageUrl: string;
    formattedPrice: string;
}

export class Product implements IProduct {
    @observable public skuId: string;
    @observable public productId: string;
    @observable public name: string;
    @observable public size: string;
    @observable public imageUrl: string;
    @observable public formattedPrice: string;

    constructor(data: Partial<IProduct>) {
        set(this, data);
    }
}
